import { useEffect } from "react";
import Pagination from '@mui/material/Pagination';
import Grid from '@mui/material/Grid';
import PaginationItem from "@mui/material/PaginationItem";
import Button from "@mui/material/Button";
import styles from './viewCampaigns.module.scss';
import TextField from "@mui/material/TextField";
import PopoverButton from "../../components/PopverButton";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import CustomTable from '../../components/CustomTable'
import initState from '../../utils/stateHandler'
import filterIcon from '../../assets/filterIcon.svg'
import { useDispatch, useSelector } from "react-redux";
import { changeStatus, getCampaignList, getCampaignsCount, updateViewTab } from "./viewCampaignReducer";
import defaults from './constants'
import { hideSummaryAction, setSummary } from "../../components/CampaignSummary/campaignSummaryReducer";
import { showNavHeadersAction } from "../../components/NavBar/navBarReducer";
import CampaignSummary from "../../components/CampaignSummary";
import { getAttributes, getProductSegment, setIsClone, setStep, setViewCampaignSelected } from "../CreateCampaigns/createCampaignReducer";
import { useNavigate } from "react-router-dom";
import Skeleton from '@mui/material/Skeleton';
import Typography from "@mui/material/Typography";
import { getProductSegmentData } from "../CreateCampaigns/helpers";
import { createCampaignQuery } from "../CreateCampaigns/constants";
import { getCounts } from './helper';
import { CAMPAIGN_STATUSES, events, routes } from "../../utils/constants";
import { sendEvents } from "../../utils/events";

const ViewCampaigns = () => {
    const { ROWS_PER_PAGE, DEFAULT_STATE, FIRST_PAGE, COLUMNS, CAMPAIGN_VIEW_TYPES, CAMPAIGNS_XS, CAMPAIGN_STATUS, CAMPAIGN_POPOVER_MENU_ACTIONS } = defaults
    const [state, setters, handlers] = initState("View Campagins")(DEFAULT_STATE)
    const store = useSelector(store => store.campaignList)
    const { showSummary, summary } = useSelector(store => store.campaignSummary)
    const campaignTypesCount = useSelector(store => store.campaignList.count);
    const campaignViewTypsCount = getCounts(campaignTypesCount);
    const productSegment = useSelector(store => store.createCampaign.productSegment)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const count = store.data.length > (ROWS_PER_PAGE) ? Math.ceil(store.data.length / ROWS_PER_PAGE) : 0
    const pageFirst = state.page + 1 > 1 ? (state.page * ROWS_PER_PAGE) + 1 : state.page + 1
    const pageLast = state.page + 1 === count ? store.data.length : (state.page + 1) * ROWS_PER_PAGE
    const tab = Object.keys(store.viewTab)[0]
    const pageOfTab = store.viewTab[tab]

    const handleChangePage = (e, newPage) => {
        setters.page(newPage - 1)
        // update the page for current tab
        dispatch(updateViewTab({type:tab, page:(newPage - 1)}))
    }

    const getList = (data) => {
        dispatch(getCampaignList(data))
        setters.disableApply(true)
    }

    const onChangeCampaignTypes = (type, label) => {
        dispatch(updateViewTab({type, page: FIRST_PAGE}))
        setters.selectedViewCampaign(type);
        setters.page(0)
        if ([CAMPAIGN_STATUS.live, CAMPAIGN_STATUS.ready, CAMPAIGN_STATUS.requested].includes(label)) {
            getList({ status: label })
            sendEvents(events.VIEW_CAMPAIGNS, { tab: label });
        } else if (type === 'user') {
            getList({ myCampaigns: true })
            sendEvents(events.VIEW_CAMPAIGNS, { tab: 'My campaigns' });
        } else {
            getList();
            sendEvents(events.VIEW_CAMPAIGNS, { tab: 'All campaigns' });
        }
    }


    const onCampaignSelect = (selectedCampagin, index) => {
        dispatch(setSummary({ ...selectedCampagin }))
        navigate(`${routes.campaignSummary}/${selectedCampagin.campaignId}`);
        dispatch(showNavHeadersAction())
        setters.selectedIndex(index)
    }

    const handleEdit = (step = 0) => {
        dispatch(setViewCampaignSelected(summary))
        dispatch(hideSummaryAction())
        dispatch(setStep(step));
        navigate(routes.createCampaign)
    }

    const handlePause = () => {
        dispatch(changeStatus({ campaignData: { ...store.data[state.selectedIndex], status: "INACTIVE" }, index: state.selectedIndex, fromSummary: true }))
    }

    const handleResume = () => {
        dispatch(changeStatus({ campaignData: { ...store.data[state.selectedIndex], status: "ACTIVE" }, index: state.selectedIndex, fromSummary: true }))
    }

    const onSearch = () => {
        const params = {};
        if (state.searchByCampaignId) {
            params.campaignId = state.searchByCampaignId;
        }
        if (state.searchByCampaignName) {
            params.campaignNameKeyword = state.searchByCampaignName;
        }
        getList(params)
    }

    const onEnter = (e) => {
        if (e.key === "Enter") {
            onSearch()
        }
    }

    const resetFilters = () => {
        setters.searchByCampaignId("");
        setters.searchByCampaignName("");
        getList()
    }

    const onMenuItemClick = (btn, campaign, index) => {
        switch (btn) {
            case "Edit":
                dispatch(setViewCampaignSelected({ ...campaign }))
                navigate(routes.createCampaign)
                break;
            case "Resume":
                dispatch(changeStatus({ campaignData: { ...campaign, status: "ACTIVE", isDeclined: false }, index }))
                break;
            case "Pause":
                dispatch(changeStatus({ campaignData: { ...campaign, status: "INACTIVE", isDeclined: false }, index }))
                break;
            case "Clone":
                dispatch(setIsClone(true))
                const clone = {...campaign, campaignStatus: CAMPAIGN_STATUSES.inputReady, stateTransitionDTOList:[], isClone: true,}
                dispatch(setViewCampaignSelected({ ...clone }))
                navigate(routes.createCampaign)
                break;
            default:
                break;
        }
    }

    const fetchSelectedTabData = () => {
        if (CAMPAIGN_STATUS[tab]) {
            for(const {type, label} of CAMPAIGN_VIEW_TYPES) {
                if(type === tab){
                    getList({status:label});
                    break;
                }
            }
        } else if (tab === 'user') {
            getList({ myCampaigns: true });
        } else {
            getList();
        }
        setters.page(pageOfTab)
    }

    const campaignCTA = (label, item, index) => (<List component="div" disablePadding>
                            <ListItem key={label} disablePadding>
                                <ListItemButton sx={{ p: "0px 20px" }} onClick={() => {
                                onMenuItemClick(label, item, index)
                                }}>
                                    <ListItemText primary={label} />
                                </ListItemButton>
                            </ListItem>
                        </List>)

    useEffect(() => {
        fetchSelectedTabData()
        dispatch(getCampaignsCount());
        dispatch(getProductSegment({entityType:createCampaignQuery.product}))
        dispatch(getAttributes({entityType:createCampaignQuery.customer}))
        dispatch(setStep(0));
        setters.selectedViewCampaign(tab)
    }, [])

    useEffect(() => {
        if (!state.searchByCampaignId && !state.searchByCampaignName) {
            fetchSelectedTabData()
        }
    }, [state.searchByCampaignId, state.searchByCampaignName])
    return <>
        {showSummary ? <CampaignSummary
            onEdit={handleEdit}
            onPause={handlePause}
            onResume={handleResume}
        /> : 
        <Grid className={styles.viewCampaignsContainer} container sx={{ padding: "25px 0px" }}>
            <Grid container item xs={12} border='0.5px solid #BCBCBC'>
                <Grid className={styles.selectCampaigns} xs={12} container direction={'row'}>
                    {CAMPAIGN_VIEW_TYPES.map(({ type, label }, idx) => (
                        <Grid xs={CAMPAIGNS_XS[idx]} item paddingY='20px' textAlign={'center'} className={state.selectedViewCampaign === type && styles.selectedCapmpaignsViewType} onClick={() => onChangeCampaignTypes(type,label)}>
                            {label} 
                            { type !== 'all' && <span> - {campaignViewTypsCount[type]}</span>}
                        </Grid>
                    ))}      
                </Grid>
                <Grid container item xs={12} justifyContent="space-between"  padding='15px' sx={{ backgroundColor: '#f7f7f7'}}>
                    {state.selectedViewCampaign === 'all' && (
                        <Grid container item xs={12} justifyContent="space-between">
                            <Grid item xs={3}>
                                <TextField InputProps={{
                                    classes: {
                                        root: styles.search
                                    },
                                    startAdornment: <img src={filterIcon} width="16px" />
                                }} size="small" fullWidth value={state.searchByCampaignId} onKeyDown={onEnter} onChange={(e) => {
                                    setters.disableApply(false)
                                    handlers.searchByCampaignId(e)
                                }} placeholder="Search by Campaign ID" />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField InputProps={{
                                    classes: {
                                        root: styles.search
                                    },
                                    startAdornment: <img src={filterIcon} width="16px" />
                                }} fullWidth size="small" value={state.searchByCampaignName} onKeyDown={onEnter} onChange={(e) => {
                                    setters.disableApply(false)
                                    handlers.searchByCampaignName(e)
                                }} placeholder="Search by Campaign name" />
                            </Grid>
                            <Grid item xs={2}>
                                {(state.searchByCampaignId || state.searchByCampaignName) && <Button
                                    fullWidth
                                    disabled={store.isLoading || state.disableApply}
                                    className={styles.buttons}
                                    variant='contained'
                                    sx={{ color: "#FFF" }}
                                    onClick={onSearch}
                                >
                                    Apply
                                </Button>}
                            </Grid>
                            <Grid item xs={1} />
                            <Grid item xs={2}>
                                <Button
                                    fullWidth
                                    color="error"
                                    disabled={!state.searchByCampaignId && !state.searchByCampaignName}
                                    className={`${styles.buttons} ${styles.clearBtn}`}
                                    variant='contained'
                                    sx={{ color: "#FFF" }}
                                    onClick={resetFilters}
                                >
                                    Clear Filters
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                    <Grid item xs={8} />
                    <Grid item container xs={4} justifyContent="flex-end" alignItems="center" marginTop="10px">
                        {store.data?.length > ROWS_PER_PAGE && <Grid item xs={6} textAlign="right" paddingRight="15px">
                            {`${pageFirst} - ${pageLast} of ${store.data.length}`}
                        </Grid>}
                        <Grid item container xs={6} justifyContent="flex-end">
                            <Pagination
                                classes={{
                                    root: styles.paginationContainer
                                }}
                                shape="rounded"
                                variant="outlined"
                                count={count}
                                hideNextButton
                                hidePrevButton
                                page={state.page + 1}
                                renderItem={(item) => <PaginationItem {...item} classes={{
                                    root: styles.paginationItem,
                                    selected: styles.selectedItem
                                }} />}
                                onChange={handleChangePage}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <CustomTable columns={COLUMNS} rows={store.data?.map(((item, index) => ({
                    campaignId: <div className={styles.clickableColumnLink} onClick={() => {
                        onCampaignSelect(item, index)
                    }}>{item.campaignId}</div>,
                    campaignName: item.campaignName,
                    campaignDuration: `${new Date(item.startTime).toLocaleDateString()} - ${new Date(item.endTime).toLocaleDateString()}`,
                    createdBy: item.createdBy,
                    campaignStatus: item.campaignStatus,
                    options: <PopoverButton>
                        {item.allowedActions.Pause ? campaignCTA(CAMPAIGN_POPOVER_MENU_ACTIONS.PAUSE, item, index) : null}
                        {item.allowedActions.Resume ? campaignCTA(CAMPAIGN_POPOVER_MENU_ACTIONS.RESUME, item, index) : null}
                        {item.allowedActions.Clone ? campaignCTA(CAMPAIGN_POPOVER_MENU_ACTIONS.CLONE, item, index) : null}
                    </PopoverButton>
                })))} page={state.page} rowsPerPage={ROWS_PER_PAGE} rowId="campaignId" />
                {store.isLoading && <>
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                    <Skeleton className={styles.skeleton} variant="rectangular" height={26} />
                </>}
                {store.error && <Typography component="div" sx={{ textAlign: "center" }}>No data found!</Typography>}
            </Grid>
        </Grid>}
    </>
}

export default ViewCampaigns;